import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';

interface IProps {
	options: { value: any; label: string }[];
	selected: any;
	handleChange: any;
}

export const RadioButtonList = ({ options, selected, handleChange }: IProps) => {
	return (
		<FormControl sx={{ width: 'fit-content' }}>
			<RadioGroup
				aria-labelledby="radio-buttons-menu"
				value={selected}
				name="radio-buttons-group"
				onChange={handleChange}
				sx={{ flexDirection: 'row', border: '1px solid', borderRadius: '4px' }}
			>
				{options?.map((option: any, index: number) => {
					return (
						<FormControlLabel
							key={index}
							value={option.value}
							control={<Radio />}
							label={option.label}
							sx={{ marginLeft: 0 }}
						/>
					);
				})}
			</RadioGroup>
		</FormControl>
	);
};
